import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { SectionHeading } from '../ui/section-heading';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const features = [
  { title: '90 minutes, fully focused', desc: 'No filler. Just the mindset and framework you need.' },
  { title: 'The builder mindset', desc: 'How to think about building with AI in 2026.' },
  { title: 'For all levels', desc: 'No coding or technical background required.' },
  { title: 'Leave with clarity', desc: 'Know exactly where to start and what to do next.' },
];

const MasterclassTeaser: React.FC = () => {
  const { ref, isVisible } = useScrollReveal(0.1);

  return (
    <div style={{ background: 'linear-gradient(160deg, #07000d 0%, #0f0118 40%, #0a000f 100%)' }}>
      <section ref={ref} className={`max-w-6xl mx-auto px-6 lg:px-8 py-28 md:py-36 transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <div className="max-w-3xl mx-auto text-center">
          <SectionHeading
            label="The Program"
            title="The AI Masterclass"
            description="90 minutes on how to use AI to build anything you want in the new age of AI."
            variant="dark"
          />

          <div className="border border-white/[0.08] rounded-2xl overflow-hidden flex flex-col sm:flex-row sm:flex-wrap text-left mb-14">
            {features.map((f, i) => (
              <div
                key={i}
                className={`flex gap-3.5 p-5 sm:w-1/2 ${
                  i < 2 ? 'border-b border-white/[0.08]' : ''
                } ${i % 2 === 0 ? 'sm:border-r border-white/[0.08]' : ''}`}
              >
                <svg className="w-5 h-5 text-purple-500 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <div>
                  <p className="text-white text-base font-semibold">{f.title}</p>
                  <p className="text-white/30 text-sm mt-0.5">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <Link to="/masterclass">
            <Button size="lg" className="rounded-full font-semibold shadow-2xl shadow-purple-600/20">
              Reserve Your Spot
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default MasterclassTeaser;
